import { showTelegramActions } from "features/Crm/modules/Bookings/modules/ManageBookings/modules/TelegramBookings/utils/TelegramBookings.utils";
import { ORDER_PAYMENT_TYPE } from "schedule-v2/constants";

const isInstalmentPaymentType = (paymentType) => {
  return (
    paymentType === ORDER_PAYMENT_TYPE.INITIAL_PART_PAYMENT ||
    paymentType === ORDER_PAYMENT_TYPE.PART_PAYMENT_INSTALLMENTS
  );
};

const hasCustomerJoiningLink = (record) => {
  const { joining_link } = record;
  return joining_link ? true : false;
};

export const shouldRenderActionColumnCell = (record, isTelegramCommunity) => {
  const { payment_type: paymentType } = record;
  // Check if the payment type is instalment or if the record is part of a Telegram community
  return (
    hasCustomerJoiningLink(record) ||
    isInstalmentPaymentType(paymentType) ||
    showTelegramActions(isTelegramCommunity, record)
  );
};
